<template>
	<div id="footer" class="mt-md-5">
		<img src="@/assets/img/footer.jpg" class="w-100" />
		<div class="container-fluid bg-primary pt-4 pb-2">
			<ul class="nav justify-content-center">
				<li class="mr-md-5">
					<p class="nav-link m-0 text-white">Copyright Cornwall Wildlife Trust</p>
				</li>
				<li class="nav-item">
					<router-link class="nav-link m-0 text-white font-weight-bold" active-class="active" :to="{ name: 'terms-and-conditions' }">
						Terms & Conditions
					</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link m-0 text-white font-weight-bold" active-class="active" :to="{ name: 'privacy-policy' }">
						Privacy Policy
					</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link m-0 text-white font-weight-bold" active-class="active" :to="{ name: 'contact-us' }">
						Contact Us
					</router-link>
				</li>
				<li class="nav-item">
					<router-link class="nav-link m-0 text-white font-weight-bold" :to="{ name: 'faq' }">FAQ's</router-link>
				</li>
			</ul>
		</div>
		<div class="container-fluid bg-primary text-center">
			<p class="text-white m-0 pb-4">
				<a class="text-white" href="https://hiyield.co.uk" target="_blank">
					Web Development Cornwall
				</a>
				by
				<a class="text-white" href="https://hiyield.co.uk" target="_blank">
					<HiYield />
				</a>
			</p>
		</div>
		<div class="modal fade" id="cookie-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="false">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-body">
						<div class="notice d-flex justify-content-between align-items-center">
							<div class="cookie-text">This website uses cookies to personalize content and analyse traffic in order to offer you a better experience.</div>
							<div class="buttons d-flex flex-column flex-lg-row">
								<a href="#" class="btn btn-primary btn-sm" @click="acceptModal">I Accept</a>
								<a href="#" class="btn btn-secondary btn-sm ml-2" data-dismiss="modal">Learn More</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import HiYield from "@/components/icons/HiYield.vue";

export default {
	name: "Footer",
	components: {
		HiYield
	},
	mounted() {
		if(localStorage.getItem("CWT_COOKIE_CONSENT") === null){
			$("#cookie-modal").modal("show");
			$("body").css("overflow", "visible");
		}
	},
	methods: {
		acceptModal(){
			localStorage.setItem("CWT_COOKIE_CONSENT", true);
			$("#cookie-modal").modal("hide");
		}
	}
}
</script>
